import {AsyncInlineError, tracer} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import GetCurrentUserService from '../../user/Services/GetCurrentUserService.js'
import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {GetAdReservationStatusRequest} from '../Requests/GetAdReservationStatusRequest.js'

/**
 * @implements UseCase
 */

class GetAdReservationStatusTransactionsUseCase extends UseCase {
  #getCurrentUserService
  #repository

  constructor({getCurrentUserService, repository}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#repository = repository
  }

  static create({config}) {
    return new GetAdReservationStatusTransactionsUseCase({
      repository: HTTPTransactionRepository.create({config}),
      getCurrentUserService: GetCurrentUserService.create({config})
    })
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'GetAdReservationStatusTransactionsUseCase#execute'})
  @AsyncInlineError()
  async execute({adId, userId = null}) {
    const userEntity = await this.#getCurrentUserService.execute()
    const resolvedUserId = userId || (userEntity ? userEntity.getId() : null)

    const requestVO = GetAdReservationStatusRequest.create({value: {adId, userId: resolvedUserId}})

    const [error, response] = await this.#repository.getAdReservationStatusNewFlow({requestVO})

    if (error) return Promise.reject(error)
    return response
  }
}

export const factory = GetAdReservationStatusTransactionsUseCase.create
